var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGetLoanIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1264 11.696C17.6 9.41454 14.2784 9.46181 10.8656 11.675C9.1512 12.7851 8 16.161 8 20.0744V22.249C8 23.2156 8.3576 24 8.8 24H23.2C23.6424 24 24 23.2156 24 22.249V20.0989C24 16.1855 22.8456 12.8079 21.1264 11.696Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2135 28C29.5411 28.7998 28.7999 29.5408 28 30.213L33.7865 36L36 33.7862L30.2135 28Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 0C25.5978 0 33 7.40143 33 16.5C33 25.5986 25.5978 33 16.5 33C7.40221 33 0 25.5986 0 16.5C0 7.40143 7.40221 0 16.5 0ZM1.57031 16.5C1.57031 24.7319 8.26696 31.4286 16.4989 31.4286C24.7308 31.4286 31.4275 24.7319 31.4275 16.5C31.4275 8.26805 24.7308 1.57141 16.4989 1.57141C8.26696 1.57141 1.57031 8.26805 1.57031 16.5Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetLoanIcon1);
export default __webpack_public_path__ + "static/media/get-loan-icon-1.2a037ffff2f78072561a516d4319a011.svg";
export { ForwardRef as ReactComponent };